import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["cx", "cy", "r", "stroke"]
const _hoisted_3 = ["cx", "cy", "r", "stroke", "stroke-dasharray", "transform"]
const _hoisted_4 = {
  key: 0,
  class: "progress-circle__text"
}

import { computed } from "vue";

interface Props {
  progress: number;
  size?: "small" | "medium" | "large";
  bgStroke?: string;
  fillStroke?: string;
  showText?: boolean;
}

const strokeWidth = 2;

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressCircle',
  props: {
    progress: { default: 0 },
    size: { default: "medium" },
    bgStroke: { default: "rgba(255, 255, 255, 0.2)" },
    fillStroke: { default: "white" },
    showText: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const sizeConfig = {
  small: { size: 24, center: 12, radius: 10, circumference: 62.83 },
  medium: { size: 48, center: 18, radius: 16, circumference: 100.53 },
  large: { size: 64, center: 32, radius: 28, circumference: 175.93 },
};

const config = computed(() => sizeConfig[props.size]);
const viewBox = computed(() => `0 0 ${config.value.size} ${config.value.size}`);
const center = computed(() => config.value.center);
const radius = computed(() => config.value.radius);
const circumference = computed(() => config.value.circumference);
const sizeClass = computed(() => `progress-circle--${props.size}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["progress-circle", sizeClass.value])
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: "progress-circle__ring",
      viewBox: viewBox.value
    }, [
      _createElementVNode("circle", {
        class: "progress-circle__bg",
        cx: center.value,
        cy: center.value,
        r: radius.value,
        fill: "none",
        stroke: __props.bgStroke,
        "stroke-width": strokeWidth
      }, null, 8, _hoisted_2),
      _createElementVNode("circle", {
        class: "progress-circle__fill",
        cx: center.value,
        cy: center.value,
        r: radius.value,
        fill: "none",
        stroke: __props.fillStroke,
        "stroke-width": strokeWidth,
        "stroke-dasharray": `${(__props.progress * circumference.value) / 100}, ${circumference.value}`,
        transform: `rotate(-90 ${center.value} ${center.value})`
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_1)),
    (__props.showText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Math.round(__props.progress)) + "%", 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})